import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Badge, Dropdown, Avatar, message } from 'antd';
import {
  HomeOutlined,
  ReadOutlined,
  ShoppingOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  LogoutOutlined,
  ProfileOutlined,
  AppstoreOutlined,
  PhoneOutlined
} from '@ant-design/icons';
import { isAuthenticated, getUser, logout } from '../utils/auth';
import { cartAPI } from '../services/api';
import { PAID_CONTENT_LABEL } from '../constants/labels';
import './Header.css';

const { Header: AntHeader } = Layout;

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);
  const [current, setCurrent] = useState('home');
  const user = getUser();

  useEffect(() => {
    // 根据路径设置当前菜单
    const path = location.pathname;
    if (path === '/') setCurrent('home');
    else if (path.startsWith('/classroom')) setCurrent('classroom');
    else if (path.startsWith('/mall')) setCurrent('mall');
    else if (path.startsWith('/about')) setCurrent('about');
    else if (path.startsWith('/contact')) setCurrent('contact');

    // 如果已登录，获取购物车数量
    if (isAuthenticated()) {
      loadCartCount();
    }

    // 监听购物车更新事件
    const handleCartUpdate = () => {
      if (isAuthenticated()) {
        loadCartCount();
      }
    };
    window.addEventListener('cartUpdate', handleCartUpdate);

    return () => {
      window.removeEventListener('cartUpdate', handleCartUpdate);
    };
  }, [location.pathname]);

  const loadCartCount = async () => {
    try {
      const res = await cartAPI.getCart();
      const count = res?.data?.count ?? res?.count ?? res?.data?.items?.length ?? 0;
      setCartCount(count);
    } catch (error) {
      console.error('获取购物车失败:', error);
    }
  };

  const handleLogout = () => {
    logout();
    message.success('已退出登录');
  };

  const userMenu = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: '个人中心',
        onClick: () => navigate('/profile')
      },
      {
        key: 'orders',
        icon: <ProfileOutlined />,
        label: '我的订单',
        onClick: () => navigate('/orders')
      },
      {
        type: 'divider'
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: '退出登录',
        onClick: handleLogout
      }
    ]
  };

  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to="/">首页</Link>
    },
    {
      key: 'classroom',
      icon: <ReadOutlined />,
      label: <Link to="/classroom">{PAID_CONTENT_LABEL}</Link>
    },
    {
      key: 'mall',
      icon: <ShoppingOutlined />,
      label: <Link to="/mall">情绪商城</Link>
    },
    {
      key: 'about',
      icon: <AppstoreOutlined />,
      label: <Link to="/about">关于我们</Link>
    },
    {
      key: 'contact',
      icon: <PhoneOutlined />,
      label: <Link to="/contact">联系我们</Link>
    }
  ];

  return (
    <AntHeader className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <h1>麦芽管家</h1>
            <span>专业情绪管理平台</span>
          </Link>
        </div>

        <Menu
          mode="horizontal"
          selectedKeys={[current]}
          items={menuItems}
          className="nav-menu"
        />

        <div className="header-actions">
          <Badge count={cartCount} className="cart-badge">
            <ShoppingCartOutlined
              className="cart-icon"
              onClick={() => navigate('/cart')}
            />
          </Badge>

          {isAuthenticated() && user ? (
            <Dropdown menu={userMenu} placement="bottomRight">
              <Avatar className="user-avatar" icon={<UserOutlined />}>
                {user.username?.charAt(0).toUpperCase()}
              </Avatar>
            </Dropdown>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="login-btn">登录</Link>
              <Link to="/register" className="register-btn">注册</Link>
            </div>
          )}
        </div>
      </div>
    </AntHeader>
  );
}

export default Header;
